import { useQuery } from "@tanstack/react-query";

import axios from "./axios";
import { usePrivateAxios } from "./use-private-axios";

interface Country {
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	id: string;
	name: string;
	capital: string;
	iso2: string;
	iso3: string;
	region: string;
	subregion: string;
	__type: string;
}
export function useCountries() {
	return useQuery({
		queryKey: ["countries"],
		queryFn: async () => {
			return (await axios.get<{ data: Country[] }>("/country/get_all_country")).data;
		}
	});
}

export interface State {
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	id: string;
	name: string;
	countryId: string;
	__type: string;
}
export function useStates(countryId: string) {
	return useQuery({
		enabled: !!countryId,
		queryKey: ["states", countryId],
		queryFn: async () => {
			const response = await axios.get<State[]>(`/country/${countryId}/states`);
			return response.data.sort((a, b) => a.name.localeCompare(b.name));
		}
	});
}

export interface City {
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	id: string;
	name: string;
	countryId: string;
	stateId: string;
	__type: string;
}
export function useCities(params: { countryId: string; stateId: string }) {
	return useQuery({
		enabled: !!params.countryId || !!params.stateId,
		queryKey: ["states", params],
		queryFn: async () => {
			const response = await axios.get<City[]>(`/country/${params.countryId}/states/${params.stateId}/cities`);
			return response.data.sort((a, b) => a.name.localeCompare(b.name));
		}
	});
}

interface Currency {
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	id: string;
	name: string;
	symbol: string;
	__type: string;
}
interface CurrencyResponse {
	data: Currency[];
	message: string;
	isSuccessful: boolean;
}

export function useCurrencies() {
	const privateAxios = usePrivateAxios();
	return useQuery({
		queryKey: ["currencies"],
		queryFn: async () => {
			const { data } = await privateAxios.get<CurrencyResponse>("/currency/list_currency");
			return data;
		}
	});
}
